import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {debounceTime, map, tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {CartOpenedEvent} from '@platform/event-bus/domain/events/cart/cart-opened.event';
import {SalesFacade} from '@features/sales/application/facades/sales.facade';

@Injectable({providedIn: 'root'})
export class SalesOnCartOpenedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly sales = inject(SalesFacade);

  constructor() {
    this.eventBus
      .ofType(CartOpenedEvent)
      .pipe(
        debounceTime(100),
        map(event => event.payload.accountId),
        tap(cartId => this.sales.handleCartOpened(cartId)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
